import { useEffect, useMemo, useState } from 'react';
import { useUserHasFeature } from 'services/omt/subscription/userPreferenceData';
import { pdRoleKey } from 'models/preferences/PreferencesMapping';
import { useUserHasAdvancedReporting } from 'services/omt/subscription/customerPremiumFeature';
import {
    useGetAllDashboards,
    useGetDashboardMetaLimits
} from 'services/gcApi/reportDashboardService/advancedReportingConfigData';

export const useUserHasAdvancesReporting = ({ viewerSocialProfile }) => {
    const [advancedReporting, setAdvancedReporting] = useState(null);
    const [pdRoles, setPDRoles] = useState(null); // Cleanup ticket: CA-167346

    // Feature Flag - Cleanup ticket: CA-167346
    const { data: pdRoleKeys, isPending: isRoleKeysFetching } = useUserHasFeature(pdRoleKey); // Cleanup ticket: CA-167346

    const hasRoles = useMemo(() => {
        return pdRoles?.length ? pdRoles.every((role) => viewerSocialProfile?.userRoles?.includes(role)) : false;
    }, [pdRoles, viewerSocialProfile?.userRoles]);

    const {
        isAvailable: hasAdvancedReportingFeature,
        isPending: isAdvancedReportingFeatureCheckLoading
    } = useUserHasAdvancedReporting(viewerSocialProfile?.garminGUID, {
        enabled: !!viewerSocialProfile?.garminGUID && !isRoleKeysFetching && hasRoles
    });

    const { data: dashboards, isLoading: isAllDashboardsLoading } = useGetAllDashboards({
        enabled: hasAdvancedReportingFeature
    });
    const { data: dashboardsLimits, isLoading: isDashboardMetaLimitsLoading } = useGetDashboardMetaLimits({
        enabled: hasAdvancedReportingFeature
    });

    const isLoading = useMemo(() => {
        return (
            isRoleKeysFetching ||
            isAdvancedReportingFeatureCheckLoading ||
            isAllDashboardsLoading ||
            isDashboardMetaLimitsLoading
        );
    }, [
        isRoleKeysFetching,
        isAdvancedReportingFeatureCheckLoading,
        isAllDashboardsLoading,
        isDashboardMetaLimitsLoading
    ]);

    const refreshValues = () => {
        if (dashboards) {
            const menus = dashboards.map((elem) => {
                return {
                    name: elem.dashboardName,
                    dashboardId: elem.dashboardID.uuid
                };
            });
            const limit = dashboards.length
                ? dashboards[0]?.dashboardLimits?.maxDashboards
                : dashboardsLimits?.maxDashboards;

            setAdvancedReporting({ advancedSubMenus: menus, dashboardsLimit: limit });
        } else {
            setAdvancedReporting({ advancedSubMenus: [], dashboardsLimit: dashboardsLimits?.maxDashboards || 5 });
        }
    };

    // Cleanup ticket: CA-167346
    useEffect(() => {
        if (!isRoleKeysFetching && pdRoleKeys) {
            // Necessary because the pdRoleKey has two roles in it
            setPDRoles(pdRoleKeys.value.split(',').map((role) => role.trim()));
        }
    }, [isRoleKeysFetching, pdRoleKeys]);

    useEffect(() => {
        if (!isLoading && hasAdvancedReportingFeature) {
            refreshValues();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasAdvancedReportingFeature, isLoading]);

    return {
        hasAdvancedReportingFeature,
        advancedReporting
    };
};
